import { useAuth0 } from '@auth0/auth0-react';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { BlankScreen } from '@strata/react-page-templates';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { getFMHTokenAndEnsureSocketConnections } from 'services/authHelpers';
import { LOGIN_REDIRECT_KEY } from 'services/constants';
import { initializePendo } from 'services/pendoUtils';
import { AppRoutes } from 'services/routes';
import { useAppDispatch } from 'store';

/**
 * Component to be rendered on callback from Auth0.
 * Handles authentication of the user and redirects to /home.
 */
export const AuthCallback = () => {
    const { isLoading, user, getAccessTokenSilently, logout } = useAuth0();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        void (async () => {
            if (!isLoading) {
                const fmhTokenResult = await getFMHTokenAndEnsureSocketConnections({
                    getAccessTokenSilently,
                    logout,
                    dispatch,
                });
                datadogRum.setUser({ id: user?.email, email: user?.email, name: user?.name });
                datadogLogs.logger.info('User Authenticated', { user });
                initializePendo(fmhTokenResult!, user);
                const redirectPath = sessionStorage.getItem(LOGIN_REDIRECT_KEY);
                navigate(redirectPath ?? AppRoutes.home);
            }
        })();
    }, [isLoading, user, dispatch, getAccessTokenSilently, navigate, logout]);

    return <BlankScreen />;
};
